import en from './en/index';
import ru from './ru/index';

export default {
    en: en,
    ru: ru,
}
